import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("svg", {
        class: _normalizeClass(["arrow", [_ctx.rotate, _ctx.scale, { 'noninteractable': _ctx.noninteractable }]]),
        width: "16",
        height: "18",
        viewBox: "0 0 16 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, [
        _createElementVNode("path", {
            class: _normalizeClass(["highlighted", [_ctx.color, _ctx.hoverStatus, { 'noninteractable': _ctx.noninteractable }]]),
            d: "M16 18L7.33664 9.00005L16 4.78745e-05L8.65202 4.77869e-05L1.07327e-07 9.00005L8.65202 18L16 18Z",
            fill: "#6F6F6F",
            "stroke-width": "0"
        }, null, 2)
    ], 2));
}
